export const colors = {
  portage: "#9195F8",
  indigo: "#54168D",
  cinnabar: "#E1454A",
  jelly: "#25809D",
  highland: "#6D9C66",
  tango: "#EE7A28",
};

export const theme = {
  breakpoints: {
    mobile: "768px",
    tablet: "992px",
    desktop: "1024px",
  },
  primary: colors.portage,
  primaryDark: colors.indigo,
  gradient: `linear-gradient(147deg, ${colors.portage} 0%, ${colors.indigo} 74%);`,
  offblack: "#242424",
  offwhite: "#fafafa",
};
